export default {
  common: {
    submitBtn: 'Konfirmasi',
    cancelBtn: 'Batal',
    condition: 'Kondisi',
    display: 'Tampilkan',
    hide: 'Sembunyikan'
  },
  tip: {
    select: 'Silakan pilih',
    input: 'Silakan masukkan'
  },
  check: {
    checkAll: 'Pilih Semua'
  },
  upload: {
    upload: 'Klik untuk unggah',
    tip: 'Seret berkas ke sini, atau'
  },
  time: {
    start: 'Mulai',
    end: 'Berakhir'
  },
  date: {
    start: 'Mulai',
    end: 'Berakhir',
    t: 'Hari Ini',
    y: 'Kemarin',
    n: '7 Hari Terakhir',
    a: 'Semua'
  },
  form: {
    printBtn: 'Cetak',
    mockBtn: 'Simulasi',
    submitBtn: 'Kirim',
    emptyBtn: 'Kosongkan'
  },
  crud: {
    excel: {
      name: 'Nama Berkas',
      type: 'Data',
      typeDic: {
        true: 'Data Saat Ini (Semua data halaman saat ini)',
        false: 'Data Dipilih (Data yang dipilih halaman saat ini)'
      },
      prop: 'Kolom',
      params: 'Parameter',
      paramsDic: {
        header: 'Header Tabel',
        data: 'Sumber Data',
        headers: 'Header Kompleks',
        sum: 'Statistik Jumlah'
      }
    },
    filter: {
      addBtn: 'Tambah Kondisi',
      clearBtn: 'Kosongkan Data',
      resetBtn: 'Reset Kondisi',
      cancelBtn: 'Batal',
      submitBtn: 'Konfirmasi'
    },
    column: {
      name: 'Nama Kolom',
      hide: 'Sembunyikan',
      fixed: 'Tetap',
      filters: 'Penyaringan',
      sortable: 'Dapat Disortir',
      index: 'Urutan',
      width: 'Lebar'
    },
    emptyText: 'Tidak ada data',
    tipStartTitle: 'Tabel saat ini telah dipilih',
    tipEndTitle: 'item',
    editTitle: 'Edit',
    copyTitle: 'Salin',
    addTitle: 'Tambah',
    viewTitle: 'Lihat',
    filterTitle: 'Kondisi Penyaringan',
    showTitle: 'Tampilkan/Sembunyikan Kolom',
    menu: 'Operasi',
    addBtn: 'Tambah',
    show: 'Tampilkan',
    hide: 'Sembunyikan',
    open: 'Membuka',
    shrink: 'Menyusut',
    printBtn: 'Cetak',
    mockBtn: 'Simulasi',
    excelBtn: 'Ekspor',
    updateBtn: 'Perbarui',
    cancelBtn: 'Batal',
    searchBtn: 'Cari',
    emptyBtn: 'Kosongkan',
    menuBtn: 'Fungsi',
    saveBtn: 'Simpan',
    viewBtn: 'Lihat',
    editBtn: 'Edit',
    copyBtn: 'Salin',
    delBtn: 'Hapus'
  }
};
